import React from 'react';
import Tooltip from '@mui/material/Tooltip';

import LabelChip from 'src/components/labels/LabelChip';
import { useUnmatchedListings } from 'src/services/api/listings/use-unmatched-listings';
import { ListingInferredType } from 'src/pages/landlord/listings/constants';

const CHIP_COLOR = 'rgb(178, 106, 0)';

type Props = {
    originalListingId: number | null | undefined;
    size?: 'compact' | 'body';
};

export default function NonPropertyInquiryChip({ originalListingId, size = 'compact' }: Props) {
    const { data } = useUnmatchedListings({ disabled: originalListingId == null });

    const listing = data?.unmatched.find((l) => l.id === originalListingId);
    if (!listing || listing.inferred_type !== ListingInferredType.FB_OTHER) {
        return null;
    }

    return (
        <Tooltip title="This lead inquired about a Facebook Marketplace listing that doesn't appear to be a rental property.">
            <span>
                <LabelChip name="Non-Property Inquiry" color={CHIP_COLOR} size={size} />
            </span>
        </Tooltip>
    );
}
